"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePlayersMenu = exports.getPlayerControlMode = exports.getPlayerSymbol = exports.getPlayerColor = exports.get = exports.localStorageKey = exports.namespace = void 0;
var crokinoleDefs_sidecar_1 = require("@crokinole/main/crokinoleDefs-sidecar");
var crokinoleGameManager_sidecar_1 = require("@crokinole/main/crokinoleGameManager-sidecar");
var crokinoleGameState_1 = require("@crokinole/main/crokinoleGameState");
var spritesUiGame_1 = require("@crokinole/recyclers/spritesUiGame");
var diveColors_1 = require("@dive/colors/diveColors");
var arrayUtils_sidecar_1 = require("@engine/arrayUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var crokinoleUi_menu_main_sidecar_1 = require("./crokinoleUi_menu_main-sidecar");
exports.namespace = 'crokinoleUi_menu_players';
exports.localStorageKey = 'crokinoleUi_menu_players';
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var obj = {
        players: [
            {
                playerType: 'human',
                controlType: 'mouse',
                colorIdx: 0,
                symbolIdx: 0,
            },
            {
                playerType: 'human',
                controlType: 'mouse',
                colorIdx: 1,
                symbolIdx: 0,
            },
            {
                playerType: 'none',
                controlType: 'mouse',
                colorIdx: 2,
                symbolIdx: 0,
            },
            {
                playerType: 'none',
                controlType: 'mouse',
                colorIdx: 3,
                symbolIdx: 0,
            },
        ],
    };
    // Load from local storage
    try {
        var jsonString = localStorage.getItem(exports.localStorageKey);
        if (jsonString) {
            var json = JSON.parse(jsonString);
            // obj.players = Object.assign([], obj.players, json.players)
            for (var i = 0; i < json.players.length && i < obj.players.length; i++) {
                Object.assign(obj.players[i], json.players[i]);
            }
        }
    }
    catch (err) {
        console.error('failed to load', exports.localStorageKey);
    }
    return obj;
};
var save = function () {
    try {
        localStorage.setItem(exports.localStorageKey, JSON.stringify(get()));
    }
    catch (err) {
        console.error('failed to save', exports.localStorageKey);
    }
};
var getPlayerColor = function (player) {
    // Remove undefined / NaNs
    if (!player.colorIdx) {
        player.colorIdx = 0;
    }
    var currentColor = arrayUtils_sidecar_1.arrayUtils.getWrappedOrFirst(crokinoleDefs_sidecar_1.crokinoleDefs.CrokinoleColors, player.colorIdx);
    assert_sidecar_1.assert.notNil(currentColor);
    return currentColor;
};
exports.getPlayerColor = getPlayerColor;
var getPlayerSymbol = function (player) {
    // Remove undefined / NaNs
    if (!player.symbolIdx) {
        player.symbolIdx = 0;
    }
    var currentSymbol = arrayUtils_sidecar_1.arrayUtils.getWrappedOrFirst(crokinoleDefs_sidecar_1.crokinoleDefs.CrokinoleDiscSymbols, player.symbolIdx);
    assert_sidecar_1.assert.notNil(currentSymbol);
    return currentSymbol;
};
exports.getPlayerSymbol = getPlayerSymbol;
var getPlayerControlMode = function (player) {
    var gamepadNum = -1;
    var controlScheme = crokinoleGameState_1.CrokinoleControlScheme.mouse;
    if (player.controlType.startsWith('gamepad-')) {
        gamepadNum = parseInt(player.controlType.split('-')[1]);
        controlScheme = crokinoleGameState_1.CrokinoleControlScheme.gamepad;
    }
    return {
        controlScheme: controlScheme,
        gamepadNum: gamepadNum,
    };
};
exports.getPlayerControlMode = getPlayerControlMode;
var updatePlayersMenu = function () {
    var addButton = crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.addButton;
    var skipButton = crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.skipButton;
    var mainMenu = crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.get();
    var isPlayersOpen = mainMenu.menuMode === 'players-lobby';
    // TODO: move out?
    mainMenu.mcy = mainMenu.mcsy;
    mainMenu.mcx = mainMenu.mcsx;
    var advanceOption = function (current, options) {
        var index = options.indexOf(current);
        index++;
        if (index >= options.length) {
            index = 0;
        }
        return options[index];
    };
    var addPlayer = function (num) {
        mainMenu.mcy = mainMenu.mcsy;
        var player = get().players[num - 1];
        var currentColor = exports.getPlayerColor(player);
        var currentSymbol = exports.getPlayerSymbol(player);
        addButton("player-" + num + " ", "Player " + num + " " + player.playerType, function () {
            player.playerType = advanceOption(player.playerType, crokinoleDefs_sidecar_1.crokinoleDefs.CrokinolePlayerTypes);
            save();
        });
        if (player.playerType !== 'none') {
            addButton("player-" + num + "-color", "Team " + currentColor.name, function () {
                player.colorIdx++;
                if (player.colorIdx >= crokinoleDefs_sidecar_1.crokinoleDefs.CrokinoleColors.length) {
                    player.colorIdx = 0;
                }
                // TODO: make sure multiple players aren't the same color
                save();
            });
            // addButton(`player-${num}-team`, `Team`, () => {
            //   save()
            // })
            addButton("player-" + num + "-symbol", "Symbol " + currentSymbol.name, function () {
                player.symbolIdx++;
                if (player.symbolIdx >= crokinoleDefs_sidecar_1.crokinoleDefs.CrokinoleDiscSymbols.length) {
                    player.symbolIdx = 0;
                }
                // TODO: make sure multiple players aren't the same color
                save();
            });
        }
        if (player.playerType === 'human') {
            addButton("player-" + num + "-input", "Controls " + player.controlType, function () {
                player.controlType = advanceOption(player.controlType, crokinoleDefs_sidecar_1.crokinoleDefs.CrokinoleControlTypes);
                save();
            });
        }
        else {
            skipButton();
        }
        if (player.playerType !== 'none') {
            var discX = mainMenu.mcx + 10;
            var discY = mainMenu.mcsy + 10;
            var imgDisc = spritesUiGame_1.spritesUiGame.getNext(discX, discY, sprites_sidecar_1.sprites.crokinoleDiscPlain[0]);
            imgDisc.tint = currentColor.tint;
            if (currentSymbol.frame) {
                var imgSymbol = spritesUiGame_1.spritesUiGame.getNext(discX, discY, currentSymbol.frame);
                imgSymbol.tint = currentColor.tint;
                imgSymbol.scale *= currentSymbol.scale || 1;
                if (currentSymbol.noTint) {
                    imgSymbol.tint = diveColors_1.diveColors.pureWhite;
                }
            }
        }
        mainMenu.mcx += mainMenu.mcw + 20;
    };
    addPlayer(1);
    addPlayer(2);
    addPlayer(3);
    addPlayer(4);
    mainMenu.mcy = mainMenu.mcsy;
    mainMenu.mcx = mainMenu.mcsx;
    mainMenu.mcy += 500;
    addButton('players-start', 'Start Game', function () {
        crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.setOpen('in-game');
        crokinoleGameManager_sidecar_1.crokinoleGameManager.goScenario_crokinole();
    }, !isPlayersOpen);
    addButton('players-back', 'Back', function () {
        // mainMenu.isPlayersOpen = false
        crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.setOpen('main-menu');
    }, !isPlayersOpen);
};
exports.updatePlayersMenu = updatePlayersMenu;
